export default __webpack_public_path__ + "static/media/gg3.2e1e949c.jpg";